(function () {
	const initProductAccordion = () => {
		// `.off` before `.on`, under our own namespace: this runs once at load
		// AND on every `shopify:section:load`, and without unbinding the second
		// pass leaves TWO handlers on each title. They then toggle in sequence
		// and cancel out, so the accordion appears completely dead. A normal
		// storefront load never fires that event, so this only bites in the
		// theme editor and under `theme dev` hot reload — i.e. exactly where the
		// client reviews. Namespaced so nothing else's handlers are touched.
		//
		// These panels are opened and closed by CSS (§17d), not here — the
		// motion is a 0.4s max-height transition. `slideUp`/`slideDown` used to
		// run underneath it as a SECOND, 300ms animation over the same box, and
		// jQuery ends a slide by RESTORING the inline height/padding/margin it
		// had spent 300ms stepping down. So at 300ms the panel's 24px bottom
		// margin snapped back from ~0 in a single frame and every hairline below
		// it jumped 22px DOWN — 100ms before the CSS curve had even finished.
		// That is the "separators suddenly jump down" the client reported on
		// 2026-08-10. `hide`/`show` keep the same display contract without
		// animating, so the About section still works if it is ever revived —
		// it carries none of §17d's rules and would otherwise be stuck open.
		$(".about__accordion-title").off("click.pkAccordion").on("click.pkAccordion", function () {
			if (!$(this).hasClass("active")) {
				$(".about__accordion-title.active").removeClass("active");
				$(this).addClass("active");
				$(".about__accordion-description").hide();
				$(this)
					.siblings(".about__accordion-description")
					.eq($(this).index())
					.show();
			} else {
				$(this).removeClass("active");
				$(this).siblings(".about__accordion-description").hide();
			}
		});
	};

	document.addEventListener("shopify:section:load", function () {
		initProductAccordion();
	});

	initProductAccordion();
})();
